import React from 'react'

import { ThemeProvider } from '@leshen/ui'
import 'typeface-roboto'
import GlobalStyles from './CustomStyles'

const Wrapper = ({ children, customTheme }) => (
  <ThemeProvider theme={customTheme}>
    <GlobalStyles />
    {children}
  </ThemeProvider>
)

export default Wrapper
